module.exports = __webpack_public_path__ + "static/seaview-hero.5f1b3310.jpg";